import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataCenter from "../modules/DataCenter";
import { Events, JSEvent } from "../utils/JSEvent";

const AutoLoginView = ({ }) => {
    const param = useParams();
    const nav = useNavigate();
    const { firebaseToken } = param;

    const [token, setToken] = useState(null);

    // useEffect(() => {
    //     setToken(firebaseToken);
    // }, [])

    useEffect(() => {
        if (firebaseToken == null) return;
        DataCenter.firebaseToken = firebaseToken;
        DataCenter.channel = "Firebase";
        //自动登录的用户不显示账户信息
        DataCenter.showAccountInfo = false;
        nav("/login");
        //发送System.Ready事件
        setTimeout(() => {
            JSEvent.emit(Events.System.Ready, {})
        }, 500);
    }, [firebaseToken])

    return <div>

    </div>
}

export default AutoLoginView;
